var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alignments",class:{disabled: _vm.isDisabled}},[(_vm.isMobile)?_c('AlignmentsMobile',_vm._g(_vm._b({},'AlignmentsMobile',_vm.alignmentsProps,false),_vm.alignmentsEmits)):_c('AlignmentsDesktop',_vm._g(_vm._b({},'AlignmentsDesktop',_vm.alignmentsProps,false),_vm.alignmentsEmits))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }